import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InstructionService } from '../../services/instruction.service';
import { LoadConfigService } from '../../services/load-config.service';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { BgColor } from '../../shared/types';

@Component({
    selector: 'app-display',
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.scss'],
    standalone: false
})
export class DisplayComponent implements OnInit, OnDestroy {
  navigationSub: Subscription;
  navigationInfo: {
    section: string;
    title: string;
    data?: { questionnairePosition: number; identifier?: number };
  } = {
    section: 'brand',
    title: 'practice-image',
    data: {
      questionnairePosition: null,
      identifier: null
    }
  };

  fingerPlacementDisplayLength = 5;
  IATQuestionDisplayLength = 3;

  // button labels
  studyStartContinueButtonLabel: string;
  continueButtonLabel: string;
  mediaContinueButtonLabel: string;
  intermissionButtonLabel: string;

  constructor(
    private navigation: StudyNavigationService,
    private loadConfigService: LoadConfigService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.navigationSub = this.navigation.navigationSubject.subscribe(info => {
      this.navigationInfo = info;
    });

    this.IATQuestionDisplayLength = this.loadConfigService.getIATQuestionDisplayLength();
    this.fingerPlacementDisplayLength = this.loadConfigService.getFingerPlacementDisplayLength();

    this.initButtonLabels();
  }

  private initButtonLabels() {
    this.continueButtonLabel = this.instructionService.getTranslationsForTerm('INSTRUCTION_CONTINUE_BUTTON');

    this.studyStartContinueButtonLabel = this.instructionService.getTranslationsForTerm('STUDY_START_CONTINUE_BUTTON');

    this.mediaContinueButtonLabel = this.instructionService.getTranslationsForTerm('MEDIA_CONTINUE_BUTTON');

    this.intermissionButtonLabel = this.instructionService.getTranslationsForTerm('INTERMISSION_CONTINUE_BUTTON');
  }

  ngOnDestroy(): void {
    this.navigationSub.unsubscribe();
  }

  get BgColors() {
    return BgColor;
  }
}
